import { render, staticRenderFns } from "./SearchMember.vue?vue&type=template&id=0605a549&"
import script from "./SearchMember.vue?vue&type=script&lang=ts&"
export * from "./SearchMember.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports